import type {
  ListInternalLayersQuery,
  ListInternalLayersFilter,
} from 'hooks/internalLayer/types';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';

export const internalLayersKeys = {
  all: () => ['internal_layers'] as const,
  list: (query: ListInternalLayersQuery) => {
    const params = buildSearchQueryParams<ListInternalLayersFilter>(query);
    return [...internalLayersKeys.all(), 'list', params] as const;
  },
  get: (internalLayerId: UUID) =>
    [...internalLayersKeys.all(), 'get', internalLayerId] as const,
};
